// Rider-side submit client for the static quote-form fallback.
//
// When the chat can't understand something, the webchat offers a deterministic quote form. It posts
// here — to the agents proxy POST /charter/leads/form-submit, which carries the M2M auth Java needs
// and files the request as a NEEDS_DISPATCH charter_lead (structured fields + the conversation so
// far). No auth header: the path is JWT-excluded, same as /charter/locations/resolve and /runs.

const AGENT_API_BASE = process.env.REACT_APP_AGENT_API_URL || 'http://localhost:8000';

// Submit the quote form. `values` is keyed by charter slot id; `transcript` is the [{role,text}]
// conversation so far (used only to seed the lead when nothing has persisted yet). Returns
// { ok: true } on success, or { ok: false, error } on a handled failure (ALREADY_BOOKED /
// SAVE_FAILED / NETWORK) so the caller can show a message and keep the form open.
export async function submitCharterForm({ sessionId, values, transcript }) {
  try {
    const res = await fetch(`${AGENT_API_BASE}/charter/leads/form-submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id: sessionId || '',
        values: values || {},
        transcript: transcript || [],
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data || !data.ok) {
      return { ok: false, error: (data && data.error) || `HTTP_${res.status}` };
    }
    return { ok: true };
  } catch (e) {
    return { ok: false, error: 'NETWORK' };
  }
}
